"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RestoreViewContainer = void 0;
var _SourceProvider = require("../SourceProvider");
var _RestoreView = require("./RestoreView");
const RestoreViewContainer = exports.RestoreViewContainer = (0, _SourceProvider.SourceProvider)(_RestoreView.RestoreView);